import React from "react";
import { Col } from "reactstrap";
import s from "./styles.scss";
import withStyles from "isomorphic-style-loader/withStyles";
import logo from "../../../media/img/vs-logo.png";
import defaultImage from "../../../media/img/sign-up.png";

export interface AuthLeftPanelProps {
  title: string;
  subtitle: string;
  imageAlt?: string;
  imageSrc?: string;
  children?: React.ReactNode;
  showImage?: boolean;
  /**
   * Horizontal wordmark on the gradient orbs; when set, the corner logo and
   * illustration image are not shown (login left panel).
   */
  centeredWordmarkSrc?: string;
  centeredWordmarkAlt?: string;
}

const AuthLeftPanel: React.FC<AuthLeftPanelProps> = ({
  title,
  subtitle,
  imageAlt = "ViewSpark",
  imageSrc = defaultImage,
  children,
  showImage = true,
  centeredWordmarkSrc,
  centeredWordmarkAlt = "ViewSPARK",
}) => {
  const showCornerLogo = !centeredWordmarkSrc;
  const showIllustration = showImage && !children && !centeredWordmarkSrc;
  const showWordmarkHero = showImage && !children && !!centeredWordmarkSrc;

  return (
    <Col md={5} className={`${s.leftPanel} d-none d-md-flex flex-column vh-100`}>
      {showCornerLogo && (
        <img src={logo} alt="ViewSpark Logo" className={s.logo} />
      )}
      <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center">
        {showIllustration && (
          <div
            className={`${s.imageWrapper} d-flex justify-content-center align-items-center mb-3`}
          >
            <div className={s.gradientLarge} />
            <div className={s.gradientSmall} />
            <img
              className={s.mainImage}
              src={imageSrc}
              alt={imageAlt}
              width={550}
              height={616}
            />
          </div>
        )}
        {showWordmarkHero && (
          <div
            className={`${s.imageWrapper} d-flex justify-content-center align-items-center mb-3`}
          >
            <div className={s.gradientLarge} />
            <div className={s.gradientSmall} />
            <img
              className={s.wordmarkImage}
              src={centeredWordmarkSrc}
              alt={centeredWordmarkAlt}
            />
          </div>
        )}
        {children}
        <div className={s.title}>{title}</div>
        <div className={s.subtitle}>{subtitle}</div>
      </div>
    </Col>
  );
};

export default withStyles(s)(AuthLeftPanel);
